module.exports = __webpack_public_path__ + "img/photos/news/small/01.jpg";